import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

/** TODO, change name */
class LaboratoryService extends AxiosService {
    constructor() {
        super('aspect-doctor-user');
    }
    /**
  * Get all studies linked to the current doctor and practice
  */
    getStudiesList = async (practiceId, page = 0, count = 5, sortDate = 0, search = null, dateFrom = null, dateTo = null, { cancelToken = null } = {}) => {
        let query = `/early-lab/?page=${page}&limit=${count}&datesort=${sortDate}`;

        if (search) {
            query += `&search=${search}`
        }
        if (dateFrom) {
            query += `&from=${dateFrom}`;
        }
        if (dateTo) {
            query += `&to=${dateTo}`;
        }
        
        const response = await this.get(query, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId,
            },
            cancelToken: cancelToken
        });
        return response;
    };
    /**
    * Get get study detail by reportId
    */
    getStudyDetail = async (sessionData, reportId, practiceId, registerDoctor = false, { cancelToken = null } = {}) => {
        const response = await this.get(`/early-lab/${reportId}`, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId,
                assignment: registerDoctor,
                socket: sessionData.socket,
                browser: sessionData.browser,
                tab: sessionData.tab
            },
            cancelToken: cancelToken
        });
        return response;
    };

    sendReview = async (reportId, review, practiceId, hl7_id, context, type, { cancelToken = null } = {}) => {
        const response = await this.post(`/early-lab/${reportId}/review`, {
            review,
            hl7_id,
            context,
            type
        }, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId,
            },
            cancelToken: cancelToken
        });
        return response;
    }

    saveDraft = async (reportId, review, practiceId, hl7_id, context, type, { cancelToken = null } = {}) => {
        const response = await this.post(`/early-lab/${reportId}/draft`, {
            review,
            hl7_id,
            context,
            type
        }, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId,
            },
            cancelToken: cancelToken
        });
        return response;
    }

    saveContext = async (reportId, context) => {
        const response = await this.post(`/early-lab/${reportId}/context`, {
            context
        }, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
        });
        return response;
    }

    generateAIComment = async (reportId) => {
        const response = await this.get(`/early-lab/${reportId}/generate-ai`, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
        });
        return response;
    }

    surveyVote = async (studyId, practiceId, option1, option2, { cancelToken = null }) => {
        const response = await this.post(`/early-lab/vote`, {
            studyId,
            survey_correct: option1,
            survey_completely: option2
        },{
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId
            },
            cancelToken: cancelToken
        });
        return response;
    }

    removeDoctor = async (doctorId, sessionData) => {
        const response = await this.get(`/early-lab/remove-doctor/`, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                doctor: doctorId,
                socket: sessionData.socket,
                browser: sessionData.browser,
                tab: sessionData.tab
            },
        });
        return response;
    }
}

export default new LaboratoryService();